import logo from "../images/wanderscript_logo.png"

export default function Navbar() {
    return (
        
        <nav>
            <img className="nav-logo" src={logo} alt="Wanderscript Logo"/>
        </nav>
    

    )
}